import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from "axios";
import { useGameCurrencyStore } from "../store/gameCurrency";

type myMutationParams ={
  credentials: Credentials;
}

type Credentials = {
  username: string;
  password: string;
};

async function fetchLogin({credentials}:myMutationParams, login_url: string) {
  const url = `integration/login`;
  const res = await axios.post<Credentials, AxiosResponse<{ currency: string, uuid: string }>>(`${login_url}${url}`, credentials); 
  return res.data;
}

export const useLogin = (login_url: string) => {
  const { setCurrency } = useGameCurrencyStore((state) => state);
  return useMutation(({credentials:Credentials}:myMutationParams) => fetchLogin({credentials:Credentials}, login_url), {
    onSuccess: (data) => {
      setCurrency(data.currency);
    },
  });
}
